// src/components/ui/atoms/WarningBadge.tsx
import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';

export type WarningType = 'avoid' | 'allergy' | 'mixed';

interface WarningBadgeProps {
  type: WarningType;
  onClick?: () => void;
  className?: string;
}

export const COLORS: Record<WarningType, string> = {
  avoid: 'text-orange-400',
  allergy: 'text-red-600',
  mixed: 'text-red-600',
};

export const BORDER_COLORS: Record<WarningType, string> = {
  avoid: 'border-orange-600',
  allergy: 'border-red-700',
  mixed: 'border-red-700',
};

export const BACKGROUND_COLORS: Record<WarningType, string> = {
  avoid: 'bg-orange-50',
  allergy: 'bg-red-50',
  mixed: 'bg-red-50',
};

export const WarningBadge: React.FC<WarningBadgeProps> = ({
  type,
  onClick,
  className = '',
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`p-1 rounded-full bg-white bg-opacity-90 hover:bg-opacity-100 ${className}`}
  >
    <FaExclamationTriangle className={`w-5 h-5 ${COLORS[type]}`} />
  </button>
);
